// extracted by mini-css-extract-plugin
export default {"tabs":"tabs__110f30e6","tab":"tab__110f30e6","xLarge":"xLarge__110f30e6","large":"large__110f30e6","medium":"medium__110f30e6","small":"small__110f30e6","xSmall":"xSmall__110f30e6"};